/* istanbul ignore file -- @preserve */
import { useMutation } from '@apollo/client';
import addContactToDepotMutation from './addContactToDepotMutation.graphql';

const useAddContactToDepotMutation = () => {
  return useMutation(addContactToDepotMutation, {
    refetchQueries: ['ManagedPlatformAccountContacts', 'DepotContacts'],
  });
};

export default useAddContactToDepotMutation;
